import allSettled from 'core-js-pure/stable/promise/all-settled';
if (!Promise.allSettled) {
  Promise.allSettled = allSettled;
}
import fromEntries from 'core-js-pure/stable/object/from-entries';
if (!Object.fromEntries) {
  Object.fromEntries = fromEntries;
}
